import { render, staticRenderFns } from "./DayBadge.vue?vue&type=template&id=4afa62c7&scoped=true&"
import script from "./DayBadge.vue?vue&type=script&lang=js&"
export * from "./DayBadge.vue?vue&type=script&lang=js&"
import style0 from "./DayBadge.vue?vue&type=style&index=0&id=4afa62c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afa62c7",
  null
  
)

export default component.exports